module.exports = __webpack_public_path__ + "img/wojuantanhuang.prt.51366053.jpg";